import React from 'react';
import { Paper, Typography } from '@mui/material';

const PatientNotes = ({ notes }) => (
  <Paper sx={{ padding: 2 }}>
    <Typography variant='h6'>Doctor's Notes</Typography>
    <Typography variant='body1'>{notes}</Typography>
  </Paper>
);

export default PatientNotes;
